export default __webpack_public_path__ + "static/media/pdf.04422922.svg";